import {collection, getAggregateFromServer, query, sum} from 'firebase/firestore'
import {fire} from "../../../fire";

export const contarWheresSumar = async ({coleccion, wheres, propiedad}) => {
    // 0 es enero

    let col = collection(fire, coleccion)
    const q = query(col, ...wheres);

    const snapshot = await getAggregateFromServer(q, {
        suma: sum(propiedad)
    });

    return {res: true, data: snapshot.data().suma}

}